@if (root) {
  <div class="modal-nav">
    <ng-container *ngComponentOutlet="root; inputs: rootParams || {}"></ng-container>
  </div>
}
